export default defineAppConfig({
  title: 'Benjamin Scharf Portfolio',
  theme: {
    dark: true,
    colors: {
      primary: '#a542b8',
    },
  },
})
